import React from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { Box } from '@chakra-ui/react'
import Navbar from './components/Navbar'
import ProblemEditorNavbar from './components/ProblemEditorNavbar'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import LandingPage from './pages/LandingPage'
import ProblemList from './pages/ProblemList'
import ProblemEditor from './pages/ProblemEditor'
import ContestList from './pages/ContestList'
import ContestDetail from './pages/ContestDetail'
import Leaderboard from './pages/Leaderboard'
import UserProfile from './pages/UserProfile'
import DocumentationOverview from './pages/docs/DocumentationOverview'
import FirstProblem from './pages/docs/FirstProblem'
import UnderstandingResults from './pages/docs/UnderstandingResults'
import ComingSoon from './pages/docs/ComingSoon'
import UIRedesignMockup from './pages/UIRedesignMockup'
import { AuthProvider } from './contexts/AuthContext'

function AppContent() {
  const location = useLocation()
  const isProblemEditor = location.pathname.startsWith('/problem/')
  const isDocumentation = location.pathname.startsWith('/docs')
  const isUIRedesign = location.pathname === '/ui-redesign-mockup'

  return (
    <Box 
      h={(isProblemEditor || isDocumentation || isUIRedesign) ? "100vh" : "100vh"} 
      bg={(isProblemEditor || isDocumentation || isUIRedesign) ? "white" : "gray.50"} 
      display="flex" 
      flexDirection="column"
      overflow={(isProblemEditor || isDocumentation || isUIRedesign) ? "hidden" : "visible"}
    >
      <ScrollToTop />
      {!isProblemEditor && !isDocumentation && !isUIRedesign && <Navbar />}
      <Box 
        as="main" 
        flex="1" 
        h={(isProblemEditor || isDocumentation || isUIRedesign) ? "100vh" : "auto"}
        overflow={(isProblemEditor || isDocumentation || isUIRedesign) ? "hidden" : "visible"}
        position={(isProblemEditor || isDocumentation || isUIRedesign) ? "relative" : "static"}
        minH={(isProblemEditor || isDocumentation || isUIRedesign) ? "100vh" : "auto"}
      >
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/problems" element={<ProblemList />} />
          <Route path="/problem/:problemId" element={<ProblemEditor />} />
          <Route path="/contests" element={<ContestList />} />
          <Route path="/contest/:contestId" element={<ContestDetail />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/docs" element={<DocumentationOverview />} />
          <Route path="/docs/overview" element={<DocumentationOverview />} />
          <Route path="/docs/first-problem" element={<FirstProblem />} />
          <Route path="/docs/understanding-results" element={<UnderstandingResults />} />
          <Route path="/docs/optimization-strategies" element={<ComingSoon title="Optimization Strategies" description="Common techniques for improving performance" />} />
          <Route path="/docs/parallel-programming" element={<ComingSoon title="Parallel Programming" description="Guide to using OpenCilk for parallel optimization" />} />
          <Route path="/docs/debugging-tips" element={<ComingSoon title="Debugging & Troubleshooting" description="Common issues and how to resolve them" />} />
          <Route path="/docs/code-editor" element={<ComingSoon title="Code Editor Features" description="Using the built-in code editor effectively" />} />
          <Route path="/docs/benchmarking" element={<ComingSoon title="Performance Benchmarking" description="Understanding benchmark results and metrics" />} />
          <Route path="/docs/profiling-tools" element={<ComingSoon title="Profiling Tools" description="Advanced profiling and analysis features" />} />
          <Route path="/docs/*" element={<ComingSoon title="Documentation" description="This documentation section is being developed" />} />
          <Route path="/ui-redesign-mockup" element={<UIRedesignMockup />} />
        </Routes>
      </Box>
      {!isProblemEditor && !isDocumentation && !isUIRedesign && <Footer />}
    </Box>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App 